/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Dropdown from 'DesignSystem/Dropdown/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration/DefaultPaymentPlans/Rulesets/Content/Ruleset/DefaultPaymentPlans/DefaultPaymentPlan/Discounts/Discount/Discounts/Content",
  onChange
  
}) {
let discountsValueData = fromData.useDataValue({ viewPath,
context: 'discounts',
})
let discountDiscountIdValueData = fromData.useDataValue({ viewPath,
context: 'discount',
path: 'discount_id',
})
let discountDiscountIdChangeData = fromData.useDataChange({ viewPath,
context: 'discount',
path: 'discount_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
 data="discounts"
 from={discountsValueData}
 data="discount.discount_id"
 selected={discountDiscountIdValueData}
 onClick={discountDiscountIdChangeData}
 valueWidth={400}
 height={300}
 field="name"
 marginBottom={dtSpaceXs}
/>
{children}
</React.Fragment>)
}